const comments = [
  {
    name: '追漫小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20person%20portrait%20avatar%2C%20simple%20clean%20background%2C%20warm%20friendly%20expression%2C%20minimal%20illustration%20style%2C%20soft%20lighting&width=96&height=96&seq=avatar-01&orientation=squarish',
    text: '用了番茄漫画之后彻底爱上了下拉式阅读！之前看漫画要一页一页翻，现在直接往下滑，节奏特别流畅，追更完全停不下来。离线缓存功能也超赞，每天通勤路上看几话，地铁没信号也不怕。',
    tag: '韩漫爱好者',
    rating: 5,
  },
  {
    name: '二次元老司机',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20adult%20portrait%20avatar%2C%20simple%20clean%20background%2C%20cool%20casual%20expression%2C%20minimal%20illustration%20style%2C%20soft%20lighting&width=96&height=96&seq=avatar-02&orientation=squarish',
    text: '作为一个看了十几年漫画的老读者，番茄漫画的竖屏滚动体验真的是革命性的。日漫的跨页大场面在手机上也能完整呈现，而且全集免费这一点太良心了，很多完结经典终于补完了。',
    tag: '日漫死忠',
    rating: 5,
  },
  {
    name: '漫画小白',
    avatar: 'https://readdy.ai/api/search-image?query=Anime%20style%20young%20female%20portrait%20avatar%2C%20simple%20clean%20background%2C%20sweet%20friendly%20expression%2C%20minimal%20illustration%20style%2C%20soft%20lighting&width=96&height=96&seq=avatar-03&orientation=squarish',
    text: '朋友推荐的，本来担心看不懂，结果发现国漫专区特别友好，画风精美剧情在线。下拉式阅读对新手来说太方便了，不像传统翻页那样容易迷失方向，推荐给所有刚开始看漫画的朋友！',
    tag: '国漫新粉',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">读者评价</h2>
          <p className="text-foreground-500 text-sm mt-2">听听漫友们怎么说番茄漫画</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((comment, i) => (
            <div key={i} className="rounded-xl bg-background-50 border border-background-200/70 p-6 flex flex-col">
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: comment.rating }).map((_, j) => (
                  <i key={j} className="ri-star-fill text-secondary-400 text-sm"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1 mb-5">
                "{comment.text}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-background-200/60">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-900">{comment.name}</p>
                  <span className="text-[10px] px-1.5 py-0.5 rounded bg-accent-100/70 text-accent-700">{comment.tag}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}